import { runInAction } from 'mobx';
import { generateQueryKey } from '../../../../utils/generate-query-key';
import { browsingDomainStore } from '../../store';
export const addShowtimeIdsForQueryOnBusinessDate = (showtimeIdsForQuery, query, businessDate) => {
    const queryKey = generateQueryKey(query);
    runInAction(() => {
        browsingDomainStore.data.showtimeIdsForQueryByBusinessDate[queryKey] = {
            [businessDate]: showtimeIdsForQuery
        };
    });
};
